<template>
                  <v-card  :loading="settlementAddStatus===1">
                    <v-card-title>
                      <span class="headline">Wygeneruj bilans otwarcia</span>
                    </v-card-title>

                    <v-card-text>
                      <v-container>
                        
                          <v-row>  
                            <v-col cols="12" sm="6" md="6">
                              <v-text-field 
                                v-model="editedItem.hour" 
                                :error-messages="hourErrors" required 
                                @input="$v.editedItem.hour.$touch()"  
                                persistent-hint
                                hint="Nadpłata - ktowa ujemna"
                                @blur="$v.editedItem.hour.$touch()" label="Pobyt"></v-text-field>                            
                            </v-col>    
                            <v-col cols="12" sm="6" md="6">
                              <v-text-field 
                                v-model="editedItem.meal" 
                                :error-messages="mealErrors" required 
                                @input="$v.editedItem.meal.$touch()"  
                                persistent-hint
                                hint="Nadpłata - ktowa ujemna"
                                @blur="$v.editedItem.meal.$touch()" label="Posiłki"></v-text-field>                            
                            </v-col>                 
                            <v-col cols="12" sm="6" md="6">
                              <v-text-field 
                                v-model="editedItem.amount" 
                                :error-messages="amountErrors" required 
                                @input="$v.editedItem.amount.$touch()"  
                                persistent-hint
                                hint="Nadpłata - ktowa ujemna"
                                @blur="$v.editedItem.amount.$touch()" label="Inne"></v-text-field>                            
                            </v-col>
                           
                          </v-row>
                        
                      </v-container>
                    </v-card-text>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="gray" text @click="close()">Anuluj</v-btn>
                      <v-btn color="primary darken-1" text @click="handleSubmit" >Generuj</v-btn>
                    </v-card-actions>
                  </v-card>
</template>

<script>
  import required from 'vuelidate/lib/validators/required'
  import { helpers } from 'vuelidate/lib/validators'
  const decimalPL = helpers.regex('decimalPL', /^[-]?\d*(\,\d+)?$/)

  export default {
    data: () => ({
        editedItem:{
            amount:undefined,
             hour:undefined,
              meal:undefined
        }
    }),
    props:['childId'],
    validations: {
      editedItem:{
        amount:{
                decimalPL
            },
            hour:{
                decimalPL
            },
            meal:{
                decimalPL
            }
      }
    },
    watch: {
        settlementAddStatus(val){
            if(val==2){
                this.close();
            }
        }
    },
    computed: {
      user(){
        return this.$store.getters.getUser;
      },
      settlementAddStatus(){
        return this.$store.getters.getSettlementAddStatus();
      },
      amountErrors () {
        const errors = []
        if (!this.$v.editedItem.amount.$dirty) return errors
        !this.$v.editedItem.amount.decimalPL && errors.push('Proszę wpisać poprawną kwotę.')
        return errors
      },
      hourErrors () {
        const errors = []
        if (!this.$v.editedItem.hour.$dirty) return errors
        !this.$v.editedItem.hour.decimalPL && errors.push('Proszę wpisać poprawną kwotę.')
        return errors
      },
       mealErrors () {
        const errors = []
        if (!this.$v.editedItem.meal.$dirty) return errors
        !this.$v.editedItem.meal.decimalPL && errors.push('Proszę wpisać poprawną kwotę.')
        return errors
      },
    },
 
    methods: {
      close(){
        this.$v.$reset();
        this.editedItem.amount = undefined;
        this.editedItem.hour = undefined;
        this.editedItem.meal = undefined;
        this.$emit('close');
      },
       handleSubmit () {
        this.$v.$touch()
        if (this.$v.$invalid) {

        } else {
                this.$store.dispatch( 'generateSettlementsBO', {
                  child_id:  this.childId,
                  amount:  this.editedItem.amount?this.editedItem.amount.toString().replace(/\./g, "").replace(/,/, "."):null,
                  hour:  this.editedItem.hour?this.editedItem.hour.toString().replace(/\./g, "").replace(/,/, "."):null,
                  meal:  this.editedItem.meal?this.editedItem.meal.toString().replace(/\./g, "").replace(/,/, "."):null
              });

        }
      },
    },
  }
</script>

